// extracted by mini-css-extract-plugin
export default {"footer":"FieldSelectionModal__footer___iogrU","title":"FieldSelectionModal__title___bOOD4","skeleton-loading":"FieldSelectionModal__skeleton-loading___qN5cR"};